import diff from 'fast-diff';
import clickstreamLogger from '~/actions/triggers';
import diffDirection from '~/helpers/diffDirection';
import EE from '~/listenerEventService/EventEmitter';
import settings from '~/utils/Settings';

function emitDiff(oldValue, newValue, target) {
  if (oldValue || newValue) {
    const difference = diff(oldValue ? oldValue : '', newValue ? newValue : '');
    clickstreamLogger.debug(
      'Form field',
      target,
      `changed ${oldValue} -> ${newValue}: ${difference}`
    );
    this.emit('analytics', {
      type: 'form-field-changed',
      target,
      oldValue,
      newValue,
      difference,
    });
  }
}

function diffSameDirection(oldValue, newValue, element) {
  const difference = diff(oldValue ? oldValue : '', newValue ? newValue : '');
  const direction = element.dataset.diffDirection;
  const newDirection = diffDirection(difference);
  element.dataset.diffDirection = newDirection;
  if (typeof direction !== 'undefined') {
    return parseInt(direction, 10) === newDirection;
  }

  return true;
}

function getValueOrInitial(element, valueName) {
  return typeof element.dataset[valueName] !== 'undefined'
    ? element.dataset[valueName]
    : element.getAttribute('value');
}

const FORM_FIELD_SELECTOR = 'input, select, textarea';

export default class FormListener extends EE {
  constructor() {
    super();
    this.timer = null;
  }

  get delay() {
    return settings.getOrDefault('FORM_FIELD_CHANGED_DELAY', 600);
  }

  timeoutHandler = (element) => {
    const value = element.value;
    const startValue = getValueOrInitial(element, 'startValue');
    emitDiff.call(this, startValue, value, element);
    this.timer = null;
    element.dataset.startValue = value;
    delete element.dataset.diffDirection;
  }

  // TODO: необходимо переработать логику onchange, сейчас ломает oninput
  onChange = (e) => {
    const element = e.target;
    const previousValue = getValueOrInitial(element, 'previousValue');
    const value = element.value;
    element.dataset.previousValue = value;
    element.dataset.startValue = previousValue;
    clickstreamLogger.debug('Change event happened!');
    emitDiff.call(this, previousValue, value, element);
  }

  onInput = (e) => {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }

    const element = e.target;

    switch (element.type) {
      case 'checkbox':
        this.emit('analytics', {
          type: 'checkbox',
          target: e.target,
          value: e.checked,
          save: false,
        });
        break;
      case 'radio':
        this.emit('analytics', {
          type: 'radio',
          target: e.target,
          value: e.checked,
          save: false,
        });
        break;
      case 'file':
        this.emit('analytics', {
          type: 'file',
          target: e.target,
          value: e.value,
          save: false,
        });
        break;
      default:
        const previousValue = getValueOrInitial(element, 'previousValue');
        const value = element.value;

        element.dataset.previousValue = value;

        if (!diffSameDirection.call(this, previousValue, value, element)) {
          const startValue = getValueOrInitial(element, 'startValue');
          emitDiff.call(this, startValue, previousValue, element);
          element.dataset.startValue = previousValue;
        }

        this.timer = setTimeout(this.timeoutHandler, this.delay, element);
    }
  }

  onFocusChange = (e) => {
    const { type, target } = e;

    if (!['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)) return;
    if (!['focus', 'blur'].includes(type)) return;
    if (['checkbox', 'radio', 'button', 'submit', 'file'].includes(target.type))
      return;

    const isFilled = !!target.value;

    this.emit('analytics', {
      type: `form-field-${type}`,
      target,
      payload: {
        type: `form-field-${type}`,
        isFilled,
      },
      save: false,
    });
  }

  start() {
    Array.prototype.forEach.call(
      document.querySelectorAll(FORM_FIELD_SELECTOR),
      (element) => {
        element.dataset.previousValue = element.value;
        element.dataset.startValue = element.value;
      }
    );
    document.addEventListener('input', this.onInput, true);
    document.addEventListener('focus', this.onFocusChange, true);
    document.addEventListener('blur', this.onFocusChange, true);
  }

  stop() {
    document.removeEventListener('input', this.onInput, true);
    document.removeEventListener('focus', this.onFocusChange, true);
    document.removeEventListener('blur', this.onFocusChange, true);
  }
}

export { diffSameDirection, getValueOrInitial };
